{
  "background": {
    "default": {
      "$type": "color",
      "$description": "Page canvas — the base background behind all content.",
      "$value": "#050709"
    },
    "subtle": {
      "$type": "color",
      "$description": "Subtly differentiated background for alternating or grouped sections.",
      "$value": "#0e1113"
    }
  },
  "surface": {
    "default": {
      "$type": "color",
      "$description": "Default container surface — cards, panels, and inputs on the page.",
      "$value": "#0e1113"
    },
    "raised": {
      "$type": "color",
      "$description": "Raised surface for higher-elevation layers (menus, popovers, dialogs). Higher elevation reads lighter in dark mode.",
      "$value": "#22272b"
    },
    "sunken": {
      "$type": "color",
      "$description": "Recessed surface for wells and inset regions.",
      "$value": "#050709"
    }
  },
  "text": {
    "default": {
      "$type": "color",
      "$description": "Primary body and heading text.",
      "$value": "#f5f5f5"
    },
    "muted": {
      "$type": "color",
      "$description": "Secondary text — supporting copy, captions, metadata.",
      "$value": "#cdd3d6"
    },
    "subtle": {
      "$type": "color",
      "$description": "Tertiary text — placeholders and disabled labels. The mid-grey reads in both modes.",
      "$value": "#888f92"
    },
    "inverse": {
      "$type": "color",
      "$description": "Text and icons rendered on an action or solid fill.",
      "$value": "#050709"
    },
    "link": {
      "$type": "color",
      "$description": "Inline hyperlink text.",
      "$value": "#8ce0ff"
    }
  },
  "border": {
    "default": {
      "$type": "color",
      "$description": "Default border for inputs, cards, and dividers.",
      "$value": "#353b3f"
    },
    "subtle": {
      "$type": "color",
      "$description": "Low-emphasis border for subtle separation.",
      "$value": "#22272b"
    },
    "strong": {
      "$type": "color",
      "$description": "High-emphasis border for focus and selected states.",
      "$value": "#888f92"
    }
  },
  "action": {
    "default": {
      "$type": "color",
      "$description": "Primary interactive colour — buttons, links, key accents. NSW navy in light, brightened for contrast in dark.",
      "$value": "#26aeff"
    },
    "hover": {
      "$type": "color",
      "$description": "Hover and active state for primary actions.",
      "$value": "#8ce0ff"
    },
    "subtle": {
      "$type": "color",
      "$description": "Tinted background for low-emphasis (ghost) actions.",
      "$value": "#001037"
    }
  },
  "success": {
    "surface": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — tinted background.",
      "$value": "#001600"
    },
    "text": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — readable text on the tint.",
      "$value": "#8fc78a"
    },
    "border": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — border and divider.",
      "$value": "#005a02"
    },
    "solid": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — solid fill for badges and icons.",
      "$value": "#399936"
    }
  },
  "warning": {
    "surface": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — tinted background.",
      "$value": "#270400"
    },
    "text": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — readable text on the tint.",
      "$value": "#eea88a"
    },
    "border": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — border and divider.",
      "$value": "#882f03"
    },
    "solid": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — solid fill for badges and icons.",
      "$value": "#d36734"
    }
  },
  "danger": {
    "surface": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — tinted background.",
      "$value": "#230002"
    },
    "text": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — readable text on the tint.",
      "$value": "#ea9294"
    },
    "border": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — border and divider.",
      "$value": "#7c061f"
    },
    "solid": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — solid fill for badges and icons.",
      "$value": "#c63f4e"
    }
  },
  "info": {
    "surface": {
      "$type": "color",
      "$description": "Info (neutral information) — tinted background.",
      "$value": "#02071c"
    },
    "text": {
      "$type": "color",
      "$description": "Info (neutral information) — readable text on the tint.",
      "$value": "#8098c2"
    },
    "border": {
      "$type": "color",
      "$description": "Info (neutral information) — border and divider.",
      "$value": "#193366"
    },
    "solid": {
      "$type": "color",
      "$description": "Info (neutral information) — solid fill for badges and icons.",
      "$value": "#4264a4"
    }
  }
}
